import { TenantConcept as TenantConcept_filmzi } from './TenantConcept.filmzi';
import { TenantConcept as TenantConcept_zoomg } from './TenantConcept.zoomg';
import { TenantConcept as TenantConcept_zoomit } from './TenantConcept.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case 'filmzi':
      return TenantConcept_filmzi;

    case 'zoomg':
      return TenantConcept_zoomg;

    default:
      return TenantConcept_zoomit;
  }
};

export const TenantConcept = IconRenderer();
